module.exports = __webpack_public_path__ + "assets/img/revisor_logo.22ea787a.svg";